import React from "react";
import { Icon, Message } from "semantic-ui-react";
import { MESSAGE_USUARIO_SIN_CLAVE_DOBLE_FACTOR } from "../../util/messageUtils";

const UsuarioNoAfiliadoClaveSmsMessage = () => {
  return (
    <Message attached="bottom" size="small" color="blue">
      <Icon name="warning circle" />
      {MESSAGE_USUARIO_SIN_CLAVE_DOBLE_FACTOR}
    </Message>
  );
};

export default UsuarioNoAfiliadoClaveSmsMessage;
